import { SabisTreeNode } from 'sabis-components2';
import { LookupItem } from "../../lookup/models";

export interface TemplateEditorInitDTO {
  templateData: EditFormTemplateDTO | null;
  listsOfValues: LOVDTO[];
}
// TemplateEditorInitDTO is the base class we are adding more properties
export interface FeedbackFormTemplateEditorInitDTO extends TemplateEditorInitDTO {
  entitiesTreeNodes: SabisTreeNode[];
  isForAllEntities: boolean;
}

export interface EditFeedbackFormsEditorDTO {
  isForAllEntities: boolean;
  sabisEntitiesIds: number[];
}

export interface EditFormTemplateDTO {
  templateId: number;
  name: string;
  description: string;
  groups: EditFormTemplateGroupDTO[];
}

export interface EditFormTemplateGroupDTO {
  groupId: number;
  internalId: string;
  name: string;
  order: number;
  description: string;
  fields: EditFormFieldDTO[];

  subGroups: EditFormTemplateGroupDTO[] | null;
}

export interface EditFormFieldDTO {
  fieldId: number;
  internalId: string;
  order: number;
  displayName: string;
  fieldType: FormFieldFieldType;
  isRequired: boolean;
  minValue: FieldMinValueDTO | null;

  hintAbove?: string;
  hintBelow?: string;
  inputTextFieldSettings?: InputTextFieldSettings;
  selectionFieldSettings?: SelectionFieldSettings;
  fileFieldSettings?: FileFieldSettings;
  labelFieldSettings?: LabelFieldSettings;

  displayRule: FieldDisplayRule | null;
  isMultilineText: boolean;

  displayIfListOfValues: LookupItem<any>[];
}

export interface FieldDisplayRule {
  fieldValueCondition: FormFieldCondition | null;
}

export interface FormFieldCondition {
  internalFieldId: string;
  operator: string;
  valueType: FieldValueType;
  value: any | null;
}

export interface LOVDTO {
  id: string;
  name: string;
  description: string;
  values: LOVValueDTO[];
}
export interface LOVValueDTO {
  valueId: string;
  displayValue: string;
}

export interface FieldMinValueDTO {
  isNow: boolean;
}

export enum FieldValueType {
  ListOfStrings = 1
}

export enum FormFieldFieldType {
  Int = 1,
  Decimal = 2,
  Text = 3,
  Selection = 4,
  DateTime = 5,
  Boolean = 6,
  Label = 7,
  File = 8,
  DateOnly = 9,
  PhoneNumber = 10,
  Email = 11,
  Number = 12,
  Time = 13,
  MultiSelection = 14
}

export interface SelectionFieldSettings {
  options: SelectionFieldOption[];
  listOfValuesId: string | null;
  allowCustomValue: boolean;
  parentFieldInternalId: string | null;
}

export interface InputTextFieldSettings {
  parentFieldInternalId: string | null;
}

export interface SelectionFieldOption {
  optionId: string | null;
  optionValue: string;
  parentOptionId: string | null;
}

export interface FileFieldSettings {
  allowedExtensions: string[] | null;
  maxFileSizeInBytes: number | null;
}

export interface LabelFieldSettings {
  text: string | null;
  isBold: boolean;
}

export enum FormTemplateType {
  Application = 'application',
  Feedback = 'feedback',
  RecruitmentEventApplication = 'recruitmenteventapplication'
}

export interface IOrderable {
  order: number;
}

export interface IFormIdentifiable {
  /** for ui usage only*/
  controlId: string;
}


